<template>
  <div class="home-container">
    <nav-header/>
    <router-view/>
    <nav-footer/>
  </div>
</template>
<script>
  import NavHeader from './../components/NavHeader'
  import NavFooter from './../components/NavFooter'
  export default{
    components:{
      NavHeader,
      NavFooter
    }
  }
</script>

<style scoped>
.home-container {
  padding-top: 99px; /* NavHeader的总高度是39px + 60px = 99px */
}
</style>